/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {ButtonBlock} from './ButtonBlock'
import {ButtonBlockToolbar} from './ButtonBlockToolbar'
import {type ButtonBlockProps} from './types'

const ButtonBlockIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.14501 2.7686V13.4613L7.57015 11.1213L9.83565 16.5087L11.5983 15.7698L9.41983 10.5907H12.95L5.14501 2.7686ZM13.0983 16.3826L9.22351 18.0069L7.16251 13.1057L4 16.1573V0L15.71 11.7358H11.1436L13.0983 16.3826Z" fill="#273540"/>
</svg>`

export {ButtonBlock, ButtonBlockToolbar, ButtonBlockIcon, type ButtonBlockProps}
